import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusTerminuProtokolu',
})
export class StatusTerminuProtokoluPipe implements PipeTransform {
  transform(datetime: string): string {
    const protocolTerm = new Date(datetime);
    const currentDatetime = new Date();
    if (protocolTerm > currentDatetime) {
      return 'Aktywny';
    }
    return 'Po czasie';
  }
}
